import h from 'hyperscript';

import { durationToISO } from 'utilities/time';
import { inject } from 'utilities/dom';

export const injectSEO = (metadata = {}) => {
    const seo = generateSEO(metadata),
        existingTag = document.querySelector('script[type="application/ld+json"]'),
        tag = (
            <script type="application/ld+json">
                { JSON.stringify(seo) }
            </script>
        );

    if (!existingTag || existingTag.innerText !== tag.innerText) {
        return inject(document.head, tag);
    } else {
        return Promise.reject('seo already injected');
    }
};

export const generateSEO = ({ title, description, thumbnail, videoSource, embedUrl, created, duration, transcript } = {}) => {
    const uploadDate = created ? new Date(created).toISOString() : '';
    
    duration = duration ? durationToISO(duration) : '';

    return {
        '@context': 'https://schema.org',
        '@type': 'VideoObject',
        name: title,
        description: description,
        thumbnailUrl: [thumbnail],
        contentUrl: videoSource,
        transcript,
        uploadDate,
        duration,
        embedUrl
    }
};